module.exports = __webpack_public_path__ + "img/volume-minus.a39bc991.svg";